import { render, staticRenderFns } from "./PostalCodeInput.vue?vue&type=template&id=7f639a5b&scoped=true&"
import script from "./PostalCodeInput.vue?vue&type=script&lang=ts&"
export * from "./PostalCodeInput.vue?vue&type=script&lang=ts&"
import style0 from "./PostalCodeInput.vue?vue&type=style&index=0&id=7f639a5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f639a5b",
  null
  
)

export default component.exports